import React from 'react'
import { Button, Header, Image, Icon, Form,label, Input,  Modal } from 'semantic-ui-react'

const ModalFotoPerfil = ({showModal, strings, onChange, cambiarFoto, closeModal, icono, onAceptar, texto, titulo, errors={},datos={} }) => (
  <Modal open={showModal}   size='tiny'>
    <Header icon={icono} content={strings?strings["fotoperfil"]:""} />
    <Modal.Content >
        <Modal.Description>
          <Header>{strings?strings["cambiarFotoPerfil"]:""}</Header>
            <Form>
              <Form.Field  >
                <label>{strings?strings["nuevafoto"]:""} </label>
                 <Input placeholder='foto'
                    onChange={onChange}
                    name="adjunto"                    
                    type='file'

                />        
                </Form.Field>
            </Form>
        </Modal.Description>
      </Modal.Content>
    <Modal.Actions>
      <Button   color='red' onClick={closeModal}  >
        <Icon name='remove' /> Cancelar
      </Button>
      <Button color='green' onClick={cambiarFoto}  >
        <Icon name='checkmark' /> Cambiar
      </Button>
    </Modal.Actions>
  </Modal>
)

export default ModalFotoPerfil